import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/About/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Blog"] */ "/vercel/path0/src/components/layouts/Blog/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/Experience/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/Friend/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Project"] */ "/vercel/path0/src/components/layouts/Project/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/Text/TextParallax.tsx");
